import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState } from 'react';
import { Button, Card, Col, Row, Spinner } from 'react-bootstrap';
import { commonStrings } from '../../../../core';
import { SubscriptionStrings } from '../../../subscription/business';
import { PaymentOptionsEnum, PaymentOptionsIconEnum, PaymentOptionsStatusEnum } from '../../business/api';
import { PaymentAdsData, PaymentStrings, SubscriptionPlanChosen, SubscriptionType } from '../../business/core';
import { PaymentOptionsFactoryImpl } from '../impl/factories';

export const PaymentAdsContent: React.FC<PaymentAdsData> = ({ paymentData, subscriptionChosen }) => {
    const [paymentChosen, setPaymentChosen] = useState<string>(PaymentOptionsEnum.BANK_SLIP);
    const chosenPlan: SubscriptionPlanChosen = { id: subscriptionChosen.id, frequency: subscriptionChosen.frequency, paymentMethod: paymentChosen }
    const paymentStrings = PaymentStrings['PTBR'];
    const subscriptionStrings = SubscriptionStrings['PTBR'].page.plans;
    const currencySymbol = commonStrings().PTBR.core.currency_symbol;
    const paymentIconsFactory = PaymentOptionsIconEnum;

    const factory = new PaymentOptionsFactoryImpl();

    const paymentOptions = Object.keys(PaymentOptionsEnum).map((option, index) => {
        return (
            <Col lg={2} md={3} sm={4} xs={4}>
                <Button
                    key={index}
                    variant={paymentChosen === PaymentOptionsEnum[option] ? "outline-primary" : "outline-secondary"}
                    style={{ width: '100%', height: 80, lineHeight: 1 }}
                    onClick={() => setPaymentChosen(PaymentOptionsEnum[option])}
                    disabled={PaymentOptionsStatusEnum[option] === 'disabled'}>
                    {paymentIconsFactory(PaymentOptionsEnum[option])} {paymentStrings.payment_options[PaymentOptionsEnum[option]].description}
                </Button>
            </Col>
        )
    })

    return (
        <div className={`font-poppins`}>
            <Card>
                <Card.Body>
                    <Row>
                        <Col xs={5} sm={5} md={4} lg={3}>
                            <h1>{paymentStrings.title} {subscriptionStrings[paymentData.name].title}</h1>
                            <p style={{ marginBottom: -5 }}>{subscriptionStrings.data_labels.adsLimit(paymentData.data[0])}</p>
                            <p>{subscriptionStrings.data_labels.titles[paymentData.data[1]]}</p>
                        </Col>
                        <Col xs={7} sm={7} md={8} lg={9}>
                            <p style={{ fontWeight: "bold" }}>{subscriptionStrings[paymentData.name].summary}</p>
                            <p style={{ fontWeight: "bold", fontSize: 24 }} className={"color-primary"}>
                                {currencySymbol} {paymentData.price}
                                <small style={{ fontSize: 12, color: 'black' }}>
                                    /{paymentData.data[1]} {subscriptionStrings.home_ads.label}
                                </small>
                            </p>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Header>
                    <Row>
                        {paymentOptions}
                    </Row>
                </Card.Header>
                <Card.Body>
                    {!chosenPlan || !paymentChosen ? <Spinner /> : factory.create(paymentChosen, chosenPlan, false, SubscriptionType.ADS)}
                </Card.Body>
            </Card>
        </div>
    )
}